/**
 * Created by Administrador on 05/11/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('manageReservationService', manageReservationService);

    manageReservationService.$inject = ['$http', 'CONFIG', 'messageService'];


    function manageReservationService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API + '/pnr';

        var service = {
            getPnrReserves: getPnrReserves,
            updatePnrReserve: updatePnrReserve,
            deletePnrReserve: deletePnrReserve
        };

        return service;

        function getPnrReserves(segmentFlightId,page,size){
            return $http.get(urlBase +"/search/pnr/allReserve/" + segmentFlightId+'?page=' + page + '&size=' + size )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updatePnrReserve(pnrId, validDate, userLogin){
            return $http.put(urlBase + "/update/pnr/validDate/" + pnrId+ "?validDate="+validDate+"&user_login=" + userLogin)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(){
                    messageService.registerUpdateError('')
                    return "error";
                });
        }

        function deletePnrReserve(codePnr, userLogin){
            return $http.put(urlBase + "/cancel/" + codePnr +"?isSold=false&isAdminAirline=true&user_login=" + userLogin)
                .then(function(response){
                    messageService.registerDelete('manageReservations');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('manageReservations');
                });
        }
    }
})();
